"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EUserServiceType = void 0;
var EUserServiceType;
(function (EUserServiceType) {
  /** Разовое занятие */
  EUserServiceType[EUserServiceType["single"] = 1] = "single";
  /** Регулярное занятие */
  EUserServiceType[EUserServiceType["regular"] = 2] = "regular";
  /** Мини-курс */
  EUserServiceType[EUserServiceType["mini"] = 3] = "mini";
  /** Курс */
  EUserServiceType[EUserServiceType["course"] = 4] = "course";
})(EUserServiceType = exports.EUserServiceType || (exports.EUserServiceType = {}));
